module.exports = new __parcel__URL__("shadowlance.dbea2af4.png").toString();